import { createIcon, IconColors } from './icon-utils';

export const InfoIcon = createIcon({
  fill: IconColors.Primary,
  path: 'M10.63 11.38a.75.75 0 0 1 0-1.5h.587c.739 0 1.337.599 1.337 1.337v2.935c0 .234.19.424.424.424h.587a.75.75 0 1 1 0 1.5h-.587a1.924 1.924 0 0 1-1.924-1.924V11.38h-.424zm1.63-3.684a.75.75 0 0 1-.75.75.457.457 0 1 0 .002-.913.457.457 0 0 0-.002.913.75.75 0 0 1 0-1.5 1.044 1.044 0 1 1 0 2.087 1.044 1.044 0 0 1 0-2.087.75.75 0 0 1 .75.75zm-.456 13.663a9.554 9.554 0 1 1 0-19.109 9.554 9.554 0 0 1 0 19.109zm0-1.5a8.054 8.054 0 1 0 0-16.109 8.054 8.054 0 0 0 0 16.109z',
});
